<ng-container *transloco="let translate">
	<ng-template #collapsedBarTpl let-user="user">
		@if (
			{
				activeRouteClass: 'active',
			};
			as vm
		) {
			<div class="w-100 fl fl-dir-c fl-gap-0q fl-ai-fs border-box">
				<a
					[routerLink]="['/', 'home', 'dashboard']"
					[routerLinkActive]="vm.activeRouteClass"
					[routerLinkActiveOptions]="{ exact: true }"
					uiNewButtonIcon
					[tooltip]="translate('home.side_navigation.home')"
				>
					<i ngProjectAs="[icon]" class="icon-home"></i>
				</a>
				<a
					[routerLink]="['/', 'home', 'chat']"
					[routerLinkActive]="vm.activeRouteClass"
					uiNewButtonIcon
					[tooltip]="translate('home.side_navigation.ai_chats')"
				>
					<i ngProjectAs="[icon]" class="icon-sparks-AI"></i>
				</a>
				@if (showMyGenie) {
					<a
						[routerLink]="['/', 'home', 'mygenie']"
						[routerLinkActive]="vm.activeRouteClass"
						uiNewButtonIcon
						[tooltip]="translate('home.side_navigation.mygenie')"
					>
						<i ngProjectAs="[icon]" class="icon-widget"></i>
					</a>
				}
				<a
					[routerLink]="['/', 'home', 'search']"
					[routerLinkActive]="vm.activeRouteClass"
					uiNewButtonIcon
					[tooltip]="translate('home.side_navigation.knowledge_base')"
				>
					<i ngProjectAs="[icon]" class="icon-knowledge-base"></i>
				</a>
				<a
					[routerLink]="['/', 'home', 'integrations']"
					[routerLinkActive]="vm.activeRouteClass"
					uiNewButtonIcon
					[tooltip]="translate('home.side_navigation.integrations')"
				>
					<i ngProjectAs="[icon]" class="icon-integrations"></i>
				</a>

				<div #contextLayerAnchor class="fl fl-ai-c fl-jc-c">
					<button
						type="button"
						uiNewButtonIcon
						class="context-layer-collapsed-toggle"
						[class.active]="$contextLayerActive()"
						[tooltip]="translate('home.side_navigation.context_layer')"
						(click)="contextLayerMenu?.open(contextLayerAnchor)"
					>
						<i
							ngProjectAs="[icon]"
							class="icon-context"
							[class.fc-primary]="$contextLayerActive()"
						></i>
					</button>
				</div>

				<reach-menu #contextLayerMenu [activeSection]="'1'">
					<ng-container
						*reachMenuSection="
							'1';
							desktopType: MenuDesktopType.FLOATING;
							anchor: contextLayerAnchor;
							widthSize: WidthSize.PX240;
							lightBg: true;
							showFooter: true;
							bordered: true;
							forcePosition: 'RIGHT'
						"
					>
						<div class="fl fl-adaptable fl-dir-c fl-gap-0h fl-ai-fs w-100">
							@if (showTaxonomies) {
								<a
									class="context-layer-menu-item fs-body1 w-100 p-1-rl p-0t-tb br-0t bg-standard-hover-on-hover fl fl-gap-1 fl-ai-c fc-500"
									style="transition: background-color 0.2s ease-in-out"
									[routerLink]="['/', 'home', 'taxonomies']"
									[routerLinkActive]="vm.activeRouteClass"
									(click)="contextLayerMenu?.close()"
								>
									<i class="fs-sp-2 fc-400 icon-taxonomy-dna"></i>
									<span class="fl-adaptable">{{
										translate('home.side_navigation.taxonomy')
									}}</span>
								</a>
							}
							<a
								class="context-layer-menu-item fs-body1 w-100 p-1-rl p-0t-tb br-0t bg-standard-hover-on-hover fl fl-gap-1 fl-ai-c fc-500"
								style="transition: background-color 0.2s ease-in-out"
								[routerLink]="['/', 'home', 'categories']"
								[routerLinkActive]="vm.activeRouteClass"
								(click)="contextLayerMenu?.close()"
							>
								<i class="fs-sp-2 fc-400 icon-label-tag"></i>
								<span class="fl-adaptable">{{
									translate('home.side_navigation.node_categories')
								}}</span>
							</a>
							<a
								class="context-layer-menu-item fs-body1 w-100 p-1-rl p-0t-tb br-0t bg-standard-hover-on-hover fl fl-gap-1 fl-ai-c fc-500"
								style="transition: background-color 0.2s ease-in-out"
								[routerLink]="['/', 'home', 'properties']"
								[routerLinkActive]="vm.activeRouteClass"
								(click)="contextLayerMenu?.close()"
							>
								<i class="fs-sp-2 fc-400 icon-add-new-property"></i>
								<span class="fl-adaptable">{{
									translate('home.side_navigation.properties')
								}}</span>
							</a>
							<a
								class="context-layer-menu-item fs-body1 w-100 p-1-rl p-0t-tb br-0t bg-standard-hover-on-hover fl fl-gap-1 fl-ai-c fc-500"
								style="transition: background-color 0.2s ease-in-out"
								[routerLink]="['/', 'home', 'relationships']"
								[routerLinkActive]="vm.activeRouteClass"
								(click)="contextLayerMenu?.close()"
							>
								<i class="fs-sp-2 fc-400 icon-relationship-type-link"></i>
								<span class="fl-adaptable">{{
									translate('home.side_navigation.relationship_types')
								}}</span>
							</a>
						</div>
					</ng-container>
				</reach-menu>
			</div>
		}
	</ng-template>

	@if (
		{
			isDesktop: isDesktop$ | async,
			sidenavOpened: sidenavOpened$ | async,
			visible: visible$ | async,
			collapsed: this.sidenavService.collapsed$ | async,
			user: user$ | async,
			activeRouteClass: 'active',
		};
		as vm
	) {
		<mat-drawer-container
			#matDrawerContainer
			[hasBackdrop]="!vm.isDesktop"
			(backdropClick)="onBackdropClick()"
			class="w-100 h-100 bg"
			style="--mat-sidenav-content-background-color: rgb(var(--color-bg-180-rgb))"
		>
			<mat-drawer
				#drawer
				[autoFocus]="false"
				[disableClose]="vm.isDesktop"
				class="drawer bg"
				[class.desktop]="vm.isDesktop"
				[class.collapsed]="vm.collapsed"
				[mode]="vm.isDesktop ? 'side' : 'push'"
				[opened]="vm.isDesktop ? vm.visible : vm.sidenavOpened"
				(openedChange)="onOpenedChange(drawer)"
				(transitionrun)="onDrawerTransitionStart($event)"
				(transitionstart)="onDrawerTransitionStart($event)"
				(transitionend)="onDrawerTransitionEnd($event)"
			>
				<div
					class="w-100 h-100 bg-190 fc-800 border-box"
					[class.pos-rel]="vm.isDesktop"
					[class.p-1-tbl]="vm.isDesktop"
				>
					<div
						class="h-100 bg-280 p-safe-tbl border-box content-container"
						[class.w-100]="!vm.isDesktop"
						[class.br-1h]="vm.isDesktop"
					>
						<div class="w-100 h-100 fl fl-dir-c fl-ai-fs fl-jc-fs border-box">
							<div
								class="w-100"
								[class.p-1-t]="vm.isDesktop"
								[class.p-2-t]="!vm.isDesktop"
								[class.p-0h-l]="!vm.isDesktop"
								[class.p-1-r]="!vm.isDesktop"
							>
								<!-- SIDENAV HEADER -->
								<sidenav-header
									class="w-100"
									[class.p-1-l]="!vm.collapsed"
									[class.p-0h-rl]="vm.collapsed"
								></sidenav-header>
							</div>
							@if (vm.isDesktop) {
								<div class="fl-fixed w-100">
									<!-- Collapsed -->
									@if ($menuContentCollapsed()) {
										<div class="w-100 p-1-t p-1-rl border-box m-0q-b">
											<ng-container
												[ngTemplateOutlet]="collapsedBarTpl"
												[ngTemplateOutletContext]="{ user: vm.user }"
											></ng-container>
										</div>
									}
									<!-- Expanded -->
									@if (!$menuContentCollapsed()) {
										<div
											class="w-100 p-1-t p-1-rl border-box fl fl-dir-c fl-gap-0q"
										>
											<div class="w-100 fl">
												<a
													[routerLink]="['/', 'home', 'dashboard']"
													[routerLinkActiveOptions]="{ exact: true }"
													[routerLinkActive]="vm.activeRouteClass"
													uiNewButtonBasic
													class="w-100"
												>
													<div
														class="w-100"
														uiNewLayoutIconText="SIZE_XL"
													>
														<i
															ngProjectAs="[icon]"
															class="fc-400 icon-home"
														></i>
														<span class="fs-body1">{{
															translate('home.side_navigation.home')
														}}</span>
													</div>
												</a>
											</div>
											<div class="w-100 fl">
												<a
													[routerLink]="['/', 'home', 'chat']"
													[routerLinkActive]="vm.activeRouteClass"
													uiNewButtonBasic
													class="w-100"
												>
													<div
														class="w-100"
														uiNewLayoutIconText="SIZE_XL"
													>
														<i
															ngProjectAs="[icon]"
															class="fc-400 icon-sparks-AI"
														></i>
														<span class="fs-body1">{{
															translate(
																'home.side_navigation.ai_chats'
															)
														}}</span>
													</div>
												</a>
											</div>
											@if (showMyGenie) {
												<div class="w-100 fl">
													<a
														[routerLink]="['/', 'home', 'mygenie']"
														[routerLinkActive]="vm.activeRouteClass"
														uiNewButtonBasic
														class="w-100"
													>
														<div
															class="w-100"
															uiNewLayoutIconText="SIZE_XL"
														>
															<i
																ngProjectAs="[icon]"
																class="fc-400 icon-widget"
															></i>
															<span class="fs-body1">{{
																translate(
																	'home.side_navigation.mygenie'
																)
															}}</span>
														</div>
													</a>
												</div>
											}
											<div class="w-100 fl">
												<a
													[routerLink]="['/', 'home', 'search']"
													[routerLinkActive]="vm.activeRouteClass"
													uiNewButtonBasic
													class="w-100"
												>
													<div
														class="w-100"
														uiNewLayoutIconText="SIZE_XL"
													>
														<i
															ngProjectAs="[icon]"
															class="fc-400 icon-knowledge-base"
														></i>
														<span class="fs-body1">{{
															translate(
																'home.side_navigation.knowledge_base'
															)
														}}</span>
													</div>
												</a>
											</div>
											<div class="w-100 fl">
												<a
													[routerLink]="['/', 'home', 'integrations']"
													[routerLinkActive]="vm.activeRouteClass"
													uiNewButtonBasic
													class="w-100"
												>
													<div
														class="w-100"
														uiNewLayoutIconText="SIZE_XL"
													>
														<i
															ngProjectAs="[icon]"
															class="fc-400 icon-integrations"
														></i>
														<span class="fs-body1">{{
															translate(
																'home.side_navigation.integrations'
															)
														}}</span>
													</div>
												</a>
											</div>

											<div
												class="w-100 fl fl-dir-c fl-gap-0q context-layer-block"
											>
												<button
													type="button"
													uiNewButtonBasic
													class="w-100 context-layer-toggle"
													[class.active]="$contextLayerActive()"
													(click)="toggleContextLayer()"
												>
													<div
														class="w-100"
														uiNewLayoutIconText="SIZE_XL"
													>
														<i
															ngProjectAs="[icon]"
															class="fc-400 icon-context"
															[class.fc-primary]="
																$contextLayerActive()
															"
														></i>
														<span class="fl fl-ai-c fl-gap-0q">
															<span
																class="fs-body1"
																(click)="openContextLayer($event)"
																>{{
																	translate(
																		'home.side_navigation.context_layer'
																	)
																}}</span
															>
															<i
																class="fl-fixed icon-chevron fs-icon-s fc-400"
																[class.chevron-down]="
																	$contextLayerExpanded()
																"
																[class.chevron-right]="
																	!$contextLayerExpanded()
																"
															></i>
														</span>
													</div>
												</button>

												<div
													class="context-layer-submenu-list"
													[class.context-layer-submenu-list--collapsed]="
														!$contextLayerExpanded() ||
														vm.collapsed ||
														$submenuEnterCollapsed()
													"
												>
													<div
														class="context-layer-submenu-list__inner w-100 fl fl-dir-c fl-gap-0q"
													>
														@if (showTaxonomies) {
															<div class="w-100 fl">
																<a
																	[routerLink]="[
																		'/',
																		'home',
																		'taxonomies',
																	]"
																	[routerLinkActive]="
																		vm.activeRouteClass
																	"
																	uiNewButtonBasic
																	class="w-100 sidenav-submenu-item"
																>
																	<div
																		class="w-100"
																		uiNewLayoutIconText="SIZE_L"
																	>
																		<i
																			ngProjectAs="[icon]"
																			class="fc-400 icon-taxonomy-dna fs-icon-s"
																		></i>
																		<span class="fs-body1">{{
																			translate(
																				'home.side_navigation.taxonomy'
																			)
																		}}</span>
																	</div>
																</a>
															</div>
														}
														<div class="w-100 fl">
															<a
																[routerLink]="[
																	'/',
																	'home',
																	'categories',
																]"
																[routerLinkActive]="
																	vm.activeRouteClass
																"
																uiNewButtonBasic
																class="w-100 sidenav-submenu-item"
															>
																<div
																	class="w-100"
																	uiNewLayoutIconText="SIZE_L"
																>
																	<i
																		ngProjectAs="[icon]"
																		class="fc-400 icon-label-tag fs-icon-s"
																	></i>
																	<span class="fs-body1">{{
																		translate(
																			'home.side_navigation.node_categories'
																		)
																	}}</span>
																</div>
															</a>
														</div>
														<div class="w-100 fl">
															<a
																[routerLink]="[
																	'/',
																	'home',
																	'properties',
																]"
																[routerLinkActive]="
																	vm.activeRouteClass
																"
																uiNewButtonBasic
																class="w-100 sidenav-submenu-item"
															>
																<div
																	class="w-100"
																	uiNewLayoutIconText="SIZE_L"
																>
																	<i
																		ngProjectAs="[icon]"
																		class="fc-400 icon-add-new-property fs-icon-s"
																	></i>
																	<span class="fs-body1">{{
																		translate(
																			'home.side_navigation.properties'
																		)
																	}}</span>
																</div>
															</a>
														</div>
														<div class="w-100 fl">
															<a
																[routerLink]="[
																	'/',
																	'home',
																	'relationships',
																]"
																[routerLinkActive]="
																	vm.activeRouteClass
																"
																uiNewButtonBasic
																class="w-100 sidenav-submenu-item"
															>
																<div
																	class="w-100"
																	uiNewLayoutIconText="SIZE_L"
																>
																	<i
																		ngProjectAs="[icon]"
																		class="fc-400 icon-relationship-type-link fs-icon-s"
																	></i>
																	<span class="fs-body1">{{
																		translate(
																			'home.side_navigation.relationship_types'
																		)
																	}}</span>
																</div>
															</a>
														</div>
													</div>
												</div>
											</div>
										</div>
									}
								</div>
							}
							<div
								teleporterHub="home-sidenav"
								class="w-100 fl-adaptable ov-auto sidenav-teleporter-hub"
								[class.sidenav-teleporter-hub--collapsed]="vm.collapsed"
							></div>
							<!-- SIDENAV FOOTER -->
							<div class="w-100 p-1">
								<div class="separator w-100"></div>
							</div>
							@if (vm.isDesktop) {
								<div class="w-100 p-1-b border-box" [class.p-1-rl]="!vm.collapsed">
									<sidenav-footer class="w-100 border-box"></sidenav-footer>
								</div>
							}
						</div>
					</div>
				</div>
			</mat-drawer>
			<mat-drawer-content>
				<div class="w-100 h-100 bg-190 fc-800 ov-h">
					<ng-content></ng-content>
				</div>
			</mat-drawer-content>
		</mat-drawer-container>
	}
</ng-container>
